import { render, staticRenderFns } from "./TenantView.vue?vue&type=template&id=7edc1afb"
import script from "./TenantView.vue?vue&type=script&lang=js"
export * from "./TenantView.vue?vue&type=script&lang=js"
import style0 from "./TenantView.vue?vue&type=style&index=0&id=7edc1afb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports